/**
 * Readable booking number (e.g. MUV100245) for a ride/order object or a raw id.
 * Records created before booking numbers existed fall back to the last 8 characters of the id.
 */
export const formatBookingCode = (value, fallback = "N/A") => {
  if (!value) return fallback;
  if (typeof value === "object") {
    if (value.bookingCode) return value.bookingCode;
    value = value._id;
  }
  return value ? `#${String(value).slice(-8).toUpperCase()}` : fallback;
};
